import { API } from './../config/api'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BoSpinnerService, BoToastrService } from 'src/@core/shared';
import { tap, catchError } from 'rxjs/operators';
import { hxUpdateModel } from './integration.DTO';
import { SUCCESS } from 'src/@shared/constants';
import { ErrorResponse } from '../config/common';

@Injectable()
export class IntegrationService {
  constructor(
    private _httpClient: HttpClient,
    private _spinner: BoSpinnerService,
    private _toastr: BoToastrService
    ) { }

  getParcelForceBase64Label(consignmentId: string): Observable<string> {
    this._spinner.show();
    const header = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8')
    return this._httpClient.get<string>(API.INTEGRATION.GET_PARCEL_FORCE_LABEL(consignmentId), {
      headers: header,
      responseType: 'text' as 'json'
    }).pipe(tap(() => this._spinner.hide()));
  }

  getTpnBase64Label(consignmentId: string): Observable<MultipleLabelsResult> {
    this._spinner.show();
    return this._httpClient.get<MultipleLabelsResult>(API.INTEGRATION.GET_TPN_LABEL(consignmentId)).pipe(tap(() => this._spinner.hide()));
  }

  getTpnTrackingUrl(consignmentId: string): Observable<string> {
    this._spinner.show();
    const header = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8')
    return this._httpClient.get<string>(API.INTEGRATION.GET_TPN_TRACKING(consignmentId), {
      headers: header,
      responseType: 'text' as 'json'
    }).pipe(tap(() => this._spinner.hide()));
  }

  getDxDepot(postCode: string): Observable<string> {
    this._spinner.show();
    const header = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8')
    return this._httpClient.get<string>(API.INTEGRATION.GET_DX_DEPOT(postCode), {
      headers: header,
      responseType: 'text' as 'json'
    }).pipe(tap(() => this._spinner.hide()));
  }

  getDxHubZone(depot: string): Observable<string> {
    this._spinner.show();
    const header = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8')
    return this._httpClient.get<string>(API.INTEGRATION.GET_DX_HUBZONE(depot), {
      headers: header,
      responseType: 'text' as 'json'
    }).pipe(tap(() => this._spinner.hide()));
  }

  getHxTracking(consignmentId: string): Observable<string> {
    this._spinner.show();
    const header = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8')
    return this._httpClient.get<string>(API.INTEGRATION.GET_HX_TRACKING(consignmentId), {
      headers: header,
      responseType: 'text' as 'json'
    }).pipe(tap(() => this._spinner.hide()));
  }

  bookHxLoad(consignmentId: string, loadId: number, quoteId: number,companyToUse:number,  agreedRate: number) {
    const header = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8')
    return this._httpClient.post<string>(API.INTEGRATION.BOOK_HX_LOADFROMQUOTE(consignmentId, loadId, quoteId, companyToUse,agreedRate),{
      headers: header,
        responseType: 'text' as 'json'
    });
  }

  updateHxLoad(consignmentIdNumber: number, externalId: number, model: hxUpdateModel): Observable<any> {
    return this._httpClient.put<any>(API.INTEGRATION.UPDATE_HX_LOAD(consignmentIdNumber, externalId), model)
      .pipe(
        tap(() => {
        this._toastr.successCode(SUCCESS.UPDATE_HX_LOAD);
      },
        (err) => {
          //console.log(err.error);
          this._toastr.error(err.error)
        })
      )
  }

  }






export class MultipleLabelsResult {
  base64Labels: string[];
}
